import { Divider, Grid, makeStyles, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import VCERNButton from "../../common/elements/VCERNButton";

import VCERNLineChart from "../../common/elements/VCERNLineChart";
import VCERNPieChart from "../../common/elements/VCERNPieChart";
import VCERNTypography from "../../common/elements/VCERNTypography";

import { connect } from "react-redux";
import icons from "../../common/icons";
import DashboardHeader from "../../common/DashboardHeader";
import InfoCard from "../../common/InfoCard";
import AC from "../../redux/actions/actionCreater";
import API from "../../common/api";
import HeadingWithLine from "../../common/elements/HeadingWithLine";
import VCERNAvatar from "../../common/elements/VCERNAvatar";
import VCERNTextField from "../../common/elements/VCERNTextField";
import { getFormattedDate } from "../../common/helper";
const minHeight = 300;
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    minHeight: minHeight,
    maxHeight: "100%",
  },
  title: { fontWeight: "bold", marginTop: 10 },

  continueButton: { margin: "10px 0" },
  graphText: { fontWeight: "bold", marginBottom: 10, textAlign: "center" },

  buttonBox: { width: "100%", textAlign: "center" },
  inviteText: { fontWeight: "bold", marginTop: 10 },
  listBox: {
    maxHeight: 400,
    overflow: "scroll",
    padding: "0 10px",
    width: "100%",
  },
  image: { height: 60, width: 60, marginRight: 15, cursor: "pointer" },
  grow: { flexGrow: 1 },
  boldText: { fontWeight: "bold" },
  listItem: { display: "flex", alignItems: "center", margin: "10px 0" },
}));

function Dashboard({
  selectedPool,
  token,
  fetchStats,
  fetchPoolEvents,
  fetchPendingMembers,
  currentOrganization,
  setCurrentPageTitle,
  setError,
}) {
  const classes = useStyles();
  const history = useHistory();

  const [stats, setStats] = useState(null);
  const [search, setSearch] = useState("");
  const [events, setEvents] = useState([]);
  const [pendingMembers, setPendingMembers] = useState([]);

  const [poolMembers, setPoolMembers] = useState([]);
  useEffect(() => {
    setCurrentPageTitle(`${currentOrganization?.name}`);
    fetchPendingMembers(currentOrganization?._id, token, setPendingMembers);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchStats(selectedPool?._id, "organization", token, setStats);
    fetchPoolEvents(selectedPool?._id, token, setEvents);
    fetchMembers();
  }, [selectedPool]);
  const fetchMembers = async () => {
    const result = await API.fetchPoolMembers(
      selectedPool?._id,
      token,
      setError
    );
    setPoolMembers(result);
  };
  console.log({ stats });
  return (
    <Grid container spacing={3}>
      <DashboardHeader />
      <Grid item xs={12} md={6}>
        <Paper className={classes.paper}>
          <VCERNTypography
            variant="body1"
            className={classes.graphText}
            value={`Total Members: ${stats?.number_of_members}`}
          />
          <VCERNPieChart
            data={[
              {
                name: "Pending",
                value: stats?.number_of_pending,
                color: "#FE9900",
              },
              {
                name: "Deceased",
                value: stats?.number_of_deceased,
                color: "#C90000",
              },
              {
                name: "Delinquent",
                value: stats?.number_of_deliquent,
                color: "#035ED9",
              },
              {
                name: "Active",
                value: stats?.number_of_active,
                color: "#1DD1A1",
              },
            ]}
          />
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper className={classes.paper}>
          <VCERNTypography
            variant="body1"
            className={classes.graphText}
            value="Financial Reports"
          />
          <VCERNPieChart
            data={[
              { name: "Raised", value: stats?.total_money, color: "#07A7E3" },
              {
                name: "Delinquent",
                value: stats?.delinquent,
                color: "#035ED9",
              },
              {
                name: "Balance",
                value: stats?.current_event_money,
                color: "#FE9900",
              },
            ]}
          />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <VCERNTypography
            variant="body1"
            className={classes.graphText}
            value="Waiting Pool status"
          />
          <VCERNLineChart data={pendingMembers} />
        </Paper>
      </Grid>
      <Grid container spacing={1} className={classes.listHeader}>
        <Grid item xs={12} md={12} lg={12}>
          <HeadingWithLine>Members List</HeadingWithLine>
        </Grid>
        <Grid item xs={12} md={6} lg={8}></Grid>
        <Grid item xs={12} md={6} lg={4}>
          <VCERNTextField
            variant="outlined"
            icon={icons.search}
            className={classes.input}
            placeholder="Search members"
            value={search}
            name="search"
            onChange={(e) => setSearch(e.target.value)}
          />
        </Grid>
      </Grid>
      <div className={classes.listBox}>
        {poolMembers
          .filter((el) => `${el?.first_name} ${el?.last_name}`.includes(search))
          .map((el, idx) => (
            <div key={idx}>
              <div className={classes.listItem}>
                <VCERNAvatar
                  className={classes.image}
                  src={el?.image}
                  onClick={() =>
                    history.push(`/member/${el?._id}`, { member: el })
                  }
                />
                <div className={classes.grow}>
                  <VCERNTypography
                    className={classes.boldText}
                    variant="body1"
                    value={`${el?.first_name} ${el?.last_name}`}
                  />
                  {el.status == "delinquent" && (
                    <VCERNTypography
                      className={classes.boldText}
                      variant="body1"
                      value={`Delinquent`}
                    />
                  )}
                  <VCERNTypography
                    className={classes.boldText}
                    variant="body2"
                    value={`Member Since: ${getFormattedDate(el?.created)}`}
                    customColor="#6F7F9F"
                  />
                </div>
              </div>
              <Divider />
            </div>
          ))}
      </div>
      {!!events.length && (
        <>
          <VCERNTypography
            variant="h5"
            className={classes.inviteText}
            value="Events Info"
          />
          <Grid container spacing={3} style={{ margin: "20px 0" }}>
            {events.map((el, idx) => (
              <>{idx < 3 && <InfoCard key={idx} event={el} />}</>
            ))}
          </Grid>
          <Grid
            container
            spacing={3}
            style={{ margin: "0 0 20px 0", justifyContent: "center" }}
          >
            <VCERNButton
              fullWidth
              startIcon={icons.eye}
              value="View All Events"
              onClick={() => history.push("/events", events)}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}
export default connect((state) => state, {
  fetchPoolEvents: AC.fetchPoolEvents,
  fetchStats: AC.fetchStats,
  fetchPendingMembers: AC.fetchPendingMembers,
  setCurrentPageTitle: AC.setCurrentPageTitle,
  setError: AC.setError,
})(Dashboard);
